import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import App from './App';
import * as serviceWorker from './serviceWorker';
import * as Sentry from '@sentry/browser';

import configureStore from './store/configureStore';
import CssBaseline from '@material-ui/core/CssBaseline';
import {MuiThemeProvider} from "@material-ui/core";
import defaultTheme from "./constants/DefaultTheme";

window['process.env'] = {
  'NODE_ENV': JSON.stringify('development')
};

Sentry.init({
  dsn: 'https://b2b6b85548374c6da7b4359ba630f60a@sentry.io/5169900',
  release: 'loopz-checkout-app@' + process.env.VERSION
});

const store = configureStore();

// A theme with custom primary and secondary color.
// It's optional.
const theme = defaultTheme;

ReactDOM.render(
  <Provider store={store}>
    <MuiThemeProvider theme={theme}>
      {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
      <CssBaseline/>
      <App store={store} theme={theme}/>
    </MuiThemeProvider>
  </Provider>
  ,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
